import React from 'react';
import { observer, inject } from 'mobx-react';

import InvertColorsIcon from "@material-ui/icons/InvertColorsRounded";
import { withStyles } from "@material-ui/core/styles"
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const ChangeTheme = ({ isDarkTheme, handleChange }) => (
  <Box
    display="flex"
    className="change_theme"
  >
    <InvertColorsIcon />
    <Box flexGrow={1} className="dark_mode_text" style={{paddingRight:5}} >Dark mode</Box>
    <AntSwitch
      checked={isDarkTheme}
      onChange={(ev) => { handleChange(ev.target.checked ? "dark_theme" : "light_theme") }}
      value="checked"
    />
  </Box>
);

const AntSwitch = withStyles(theme => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: "white",
    '&$checked': {
      transform: 'translateX(12px)',
      color: "#5e5e5e",
      '& + $track': {
        opacity: 1,
        backgroundColor: "white",
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#5e5e5e",
  },
  checked: {},
}))(Switch);

export default observer(ChangeTheme);